import image1 from "../assets/piyush.jpg";
import image2 from "../assets/hero_image1.jpg";
import image3 from "../assets/ankush.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'PIYUSH DHIMAN',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'Here We provide you best health programs which are ideal for your body type ',
    name: 'YUVRAJ BHATIA',
    status: 'COACH'
  },
  {
    image : image3,
    review:'Yuvraj fitclub is one of the most beneficial club if you want to change your body',
    name: 'ANKUSH CHABBHRA',
    status: "CUSTOMER"
  }
];
